<div class="row w100 space-between">
    <div class="col">
        <h1>Project Exports</h1>
        <div>
            Export your Figma Site to a project to create Stream Closings from
            that Project.
        </div>
    </div>
    <div class="col">
        <rr-btn
            type="Primary"
            size="Medium"
            iconStart="add"
            (click)="addressource()"
            >Export from Figma</rr-btn
        >
    </div>
</div>
<div class="wrapper col gap-8 w100">
    @for (project of projectList; track project.id) {
        <div class="card w100 col gap-8">
            <div class="row space-between w100 align-center">
                <div class="col">
                    <h3>{{ project.name }}</h3>
                    <div class="tiny">
                        last update:
                        {{
                            project.dateUpdated
                                ? (project.dateUpdated | getLocaldateByTime)
                                : (project.dateCreate | getLocaldateByTime)
                        }}
                    </div>
                </div>
                <div class="row gap-8 align-center">
                    <rr-btn
                        type="Link"
                        size="Small"
                        (btnclick)="deleteExport(project.id)"
                        >delete</rr-btn
                    >
                    <!-- <rr-btn type="Link" size="Small">Preview</rr-btn> -->
                    <rr-btn
                        type="Secondary"
                        size="Small"
                        (click)="reload(project.id)"
                        >Reload</rr-btn
                    >
                </div>
            </div>
            <div class="row gap-8 align-center">
                <rr-btn type="Link" size="Small" (click)="deleteFigmaExport(project.id)">delete</rr-btn>
                <rr-btn
                    type="Secondary"
                    size="Small"
                    (click)="reload(project.id)"
                    >Reload</rr-btn
                >
            </div>
        </div>
    }
</div>
@if (isLoading === true) {
    <rr-spinner></rr-spinner>
}
